module.exports = __webpack_public_path__ + "img/item_CommIllustration_01a.db0dca3f.jpeg";